/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { State } from 'modules';
// eslint-disable-next-line no-restricted-imports
import { loadBoard } from 'modules/loaders/load-board';
// eslint-disable-next-line no-restricted-imports
import {
  socketBoard,
  socketCard,
  socketMember,
  socketNotification,
  socketOrganization,
  socketReaction,
} from 'modules/sockets';
import { Store } from 'redux';
import subscribe, { Deleted, LiveUpdate } from 'scripts/init/live-updater';
// eslint-disable-next-line no-restricted-imports
import { getBoardById } from 'selectors/boards';
// eslint-disable-next-line no-restricted-imports
import { isFilteringByUnreadNotifications } from 'selectors/notifications';
// eslint-disable-next-line no-restricted-imports
import { BoardResponse } from 'types/responses';

export default (store: Store<State>) => {
  const { dispatch, getState } = store;

  subscribe(
    (update: LiveUpdate): ReturnType<typeof dispatch> => {
      // eslint-disable-next-line default-case
      switch (update.typeName) {
        case 'Board':
          if (
            !getBoardById(getState(), update.delta.id) &&
            !(update.delta as Deleted).deleted &&
            !(update.delta as BoardResponse).prefs
          ) {
            /*
             * If we receive a socket update to add a new board we don't have in state that does
             * not have prefs defined - fetch the model from the server and then add it rather than
             * put a partial model into the state
             */
            return dispatch(loadBoard(update.delta.id));
          }

          return dispatch(socketBoard(update.delta));

        case 'Card':
          return dispatch(socketCard(update.delta));

        case 'Member':
          return dispatch(socketMember(update.delta));

        case 'Notification':
          return dispatch(
            socketNotification({
              delta: update.delta,
              isFilteringByUnreadNotifications: isFilteringByUnreadNotifications(
                getState(),
              ),
            }),
          );

        case 'Organization':
          return dispatch(socketOrganization(update.delta));

        case 'Reaction':
          return dispatch(socketReaction(update.delta));
      }
    },
  );
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/apply-socket-updates.ts